export const environment = {
  production: false,
  oidcAuthority: 'https://login-dev.allplan.com/realms/allplan',
  connect2ApiBaseUrl: 'https://api-dev-connect2.allplan.com',
  matomoUrl: 'https://awt.allplan.com/pwk ',
  matomoSiteId: '73',
  matomoEnabled: true
};